<template>
  <div>
    <input type="checkbox" id="my-modal2" class="modal-toggle" :checked="isLogout">
    <div class="modal">
      <div class="modal-box">
        <!-- <h3 class="font-bold text-lg">НЭВТРЭХ</h3> -->
        <div class="flex-0 btn btn-ghost px-2 flex items-center">
          <div class="font-title normal-case text-primary inline-flex text-lg transition-all duration-200 md:text-3xl">
            <span>Гарах <span class="text-base-content">цонх</span></span>
          </div>
        </div>
        <div class="py-3">
          <div class="alert">
            <div>
              <hero-icon name="exclamation"/>
              <span>Та системээс гарахдаа итгэлтэй байна уу?</span>
            </div>
          </div>
        </div>
        <div class="modal-action">
          <my-button type="link" size="default" @click="is_logout(false)"><span class="normal-case">Үгүй</span></my-button>
          <my-button type="primary" size="default" icon="logout" @click="handleLogout">Тийм</my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['isLogout'])
  },
  methods: {
    ...mapActions(['is_logout', 'set_user']),
    handleLogout () {
      this.is_logout(false)
      localStorage.removeItem('token')
      this.set_user(null)
    }
  }
}
</script>
